<template>
  <div class="nav-mainMenu">
    <div class="nav-mainMenu-item" @click="screenClientsBookSelected">
      <div class="btn-profil"></div>
    </div>
    <div class="nav-mainMenu-item" @click="screenStatsSelected">
      <div class="btn-stats"></div>
    </div>
    <div class="nav-mainMenu-item" @click="showHideScreenReviews">
      <div class="btn-leaveRate"></div>
    </div>
    <el-popover placement="right" width="360" trigger="click" popper-class="nav-mainMenu-sub-container"
      v-model="parametersMenu">
      <div class="nav-mainMenu-sub" v-if="getUser !== null">
        <div class="nav-mainMenu-sub-item nav-mainMenu-sub-header">{{ getAllInfos.restoName }}</div>
        <div class="nav-mainMenu-sub-item" @click="printResas">Imprimer les réservations affichées</div>
        <div class="nav-mainMenu-sub-item" @click="screenResaListSelected">Listing des réservations par date</div>
        <div class="nav-mainMenu-sub-item" @click="reloadApp">Recharger</div>
        <div class="nav-mainMenu-sub-item" @click="screenServicesSelected">Paramétrer les services</div>
        <div class="nav-mainMenu-sub-item" @click="screenEventsSelected">Paramétrer les évènements</div>
        <div class="nav-mainMenu-sub-item" @click="screenDiscountSelected">Paramétrer les réductions</div>
        <div class="nav-mainMenu-sub-item" @click="popupCreateRoomSelected">Paramétrer les salles</div>
        <div class="nav-mainMenu-sub-item" @click="screenIntegrationSelected">Intégration</div>
        <div class="nav-mainMenu-sub-item" @click="screenInfosSelected">Informations générales</div>
        <div class="nav-mainMenu-sub-item" v-if="!getNotifIsAllowed" @click="allowNotification">Activer les
          notifications</div>
        <div class="nav-mainMenu-sub-item" @click="logout">Logout</div>
        <div class="nav-mainMenu-sub-item" v-if="isPermanance" @click="permananceScreen">Permanence</div>
      </div>
      <div slot="reference" class="nav-mainMenu-item-line btn-properties nav-toggle nav-toggle-white nav-toggle-size2">
        <div id="nav-icon3" :class='{ "open": parametersMenu }'><span></span><span></span><span></span><span></span>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import router from '../../router';

export default {
  name: 'MainMenu',
  data() {
    return {
      parametersMenu: false
    }
  },
  computed: {
    ...mapGetters({
      getUser: 'newUsers/getUser',
      getAllInfos: 'infos/getAllInfos',
      getCurrentDateLinearUnShorted: 'calendar/getCurrentDateLinearUnShorted'
    }),
    isPermanance: function () {
      return this.$router.currentRoute.name === 'PRedirect'
    },
    getNotifIsAllowed: function () {
      if (!('Notification' in window)) return true // for devices not support Notifications
      if (Notification.permission === 'granted') return true
      return false
    }
  },
  methods: {
    ...mapActions({
      showHideScreenServices: 'displayer/showHideScreenServices',
      showHideScreenEvents: 'displayer/showHideScreenEvents',
      showHideScreenDiscount: 'displayer/showHideScreenDiscount',
      showHidePopupCreateRoom: 'displayer/showHidePopupCreateRoom',
      showHideScreenStats: 'displayer/showHideScreenStats',
      showHideScreenIntegration: 'displayer/showHideScreenIntegration',
      showHideScreenInfos: 'displayer/showHideScreenInfos',
      showHideScreenReviews: 'displayer/showHideScreenReviews',
      showHideScreenClientsBook: 'displayer/showHideScreenClientsBook',
      showHideScreenCashList: 'displayer/showHideScreenCashList',
      showHideScreenResaList: 'displayer/showHideScreenResaList',
      checkNotificationAuth: 'serviceWorker/checkNotificationAuth',
      hideAll: 'displayer/hideAll',
      logout: 'newUsers/logout'
    }),
    allowNotification: function () {
      this.checkNotificationAuth()
      this.parametersMenu = false
    },
    screenServicesSelected: function () {
      this.parametersMenu = false
      this.showHideScreenServices()
    },
    screenStatsSelected: function () {
      this.parametersMenu = false
      this.showHideScreenStats()
    },
    screenEventsSelected: function () {
      this.parametersMenu = false
      this.showHideScreenEvents()
    },
    screenDiscountSelected: function () {
      this.parametersMenu = false
      this.showHideScreenDiscount()
    },
    popupCreateRoomSelected: function () {
      this.parametersMenu = false
      this.showHidePopupCreateRoom()
    },
    screenIntegrationSelected: function () {
      this.parametersMenu = false
      this.showHideScreenIntegration()
    },
    screenInfosSelected: function () {
      this.parametersMenu = false
      this.showHideScreenInfos()
    },
    screenClientsBookSelected: function () {
      this.parametersMenu = false
      this.showHideScreenClientsBook()
    },
    screenCashListSelected: function () {
      this.parametersMenu = false
      this.showHideScreenCashList()
    },
    screenResaListSelected: function () {
      this.parametersMenu = false
      this.showHideScreenResaList()
    },
    reloadApp: function () {
      window.localStorage.clear()
      window.location.reload()
    },
    permananceScreen: function () {
      router.push({ name: 'Permanence' })
    },
    img_thumbnail: function (w, src, alt) {
      var img = w.document.createElement('img')
      img.setAttribute('src', src)
      img.width = '80'
      img.height = '80'
      w.document.body.appendChild(img)
    },
    printResas: function (e) {
      e.preventDefault()
      e.stopPropagation()
      var mywindow = window.open('', 'PRINT', 'height=600,width=800')

      mywindow.document.write(`<html><head><title>${document.title}</title>`)
      mywindow.document.write('<style type="text/css">body{font-family:Arial}.el-col{display:inline-block}.resaline-state{display:none;}.resaline-row:before{content:" - ";display:inline-block; margin-right:10px;}.resaline-tags{display:none;}</style>')
      mywindow.document.write('</head><body >')
      // set logo image
      var img = mywindow.document.createElement('img')
      img.setAttribute('src', 'https://staging.resa.ninja/icons/apple-touch-icon-120x120.png')
      img.style.display = 'block'
      img.style.position = 'absolute'
      img.style.left = '0'
      img.width = '80'
      img.height = '80'
      mywindow.document.body.appendChild(img)

      mywindow.document.write(`<div style="text-align:center; font-size:23px;margin-bottom:15px;"><strong>${this.getAllInfos.restoName}</strong><br><strong>${this.getCurrentDateLinearUnShorted}</strong><br>Service du <strong>${document.getElementById('serviceToPrint').innerText}</strong></div>`)
      // retrive all resas to print with classname print-ok
      let resasToPrint = document.getElementById('resasToPrint').getElementsByClassName('print-ok')
      let innerHtml = ''
      for (let i = 0; i < resasToPrint.length; i++) {
        innerHtml += resasToPrint[i].innerHTML
      }
      // print
      mywindow.document.write(innerHtml)
      mywindow.document.write('</body></html>')

      mywindow.document.close() // necessary for IE >= 10
      mywindow.focus() // necessary for IE >= 10*/

      // hack for ios don't update dom imediatly
      /* this.$nextTick(() => {
        mywindow.print()
        // mywindow.close()
      }) */

      mywindow.onafterprint = () => {
        mywindow.close()
      }
      mywindow.onload = () => {
        mywindow.print()
      }

      return true
    }
  }
}
</script>

<style lang="scss"></style>
